import React from "react"
import PropTypes from "prop-types"
// import { sortBy } from "lodash"
import classNames from "classnames"
import { useRefinementList  } from 'react-instantsearch';

const checkboxClasses = item => classNames({
	checkbox: true,
	"is-active": item.isRefined,
})

 function Checkbox({ item, refine, replaceLabel }){
   return   (
        <div className={checkboxClasses(item)} onClick={() => refine(item.value)}>
        <div className="checkbox__indicator">
            {item.isRefined
                ? <svg><use xlinkHref="#tick" /></svg>
                : null}
        </div>
        {replaceLabel || item.label }
    </div>)
 }
Checkbox.propTypes = {
    item: PropTypes.shape({
		label: PropTypes.string,
	}),
	refine: PropTypes.func,
	replaceLabel: PropTypes.string,
};

 function Checkboxes({ attributeName, replaceLabel }){
    
    const { items, refine } = useRefinementList({attribute: attributeName});
    return ( <div className="checkbox-group">
        {items.map(item => <Checkbox key={item.label} item={item} refine={refine} replaceLabel={replaceLabel} />)}
    </div>
    )
}
Checkboxes.propTypes = {
  	items: PropTypes.arrayOf(PropTypes.object),
	refine: PropTypes.func,
	replaceLabel: PropTypes.string,
};
export default Checkboxes